import React from 'react';
import SingleWarning from './SingleWarning';

const SingleDiet = ({
	list,
}) => (
	<ul className="unformated-list single-warnings">
		{list.map((name, i) =>
			<SingleWarning 
				key={i}
				name={name} />
			)}
	</ul>
);

export default SingleDiet;


// WEBPACK FOOTER //
// ./src/diets/SingleDiet.js